module.exports = "https://web-assets.ifttt.com/packs/media/onboarding_recommendations/applet_intro-617c0a0e.svg";